import { useTranslation } from 'react-i18next'

import { Icon } from '@lib/components'

import { IconStyles } from '@lib/components/Icon/styles'

import styles from './styles.module.scss'
import { ContextMenuItemsProps } from './types'

export const ContextMenuItems = ({
  isSafe,
  canMarkAsSpamOrSafe = true,
  onShowSpamReport,
  onMarkAsSafe,
  onMarkAsSpam,
  onCopyMessageID,
}: ContextMenuItemsProps) => {
  const { t } = useTranslation()

  return (
    <>
      {canMarkAsSpamOrSafe
        ? isSafe
          ? (
            <div className={styles.menuItem} onClick={onMarkAsSpam}>
              <Icon path="icons/icon-warning" style={IconStyles.medium} />
              <div>{t('Chat.Message.ContextMenu.MarkAsSpam')}</div>
            </div>
          )
          : (
            <div className={styles.menuItem} onClick={onMarkAsSafe}>
              <Icon path="icons/icon-safe" style={IconStyles.medium} />
              <div>{t('Chat.Message.ContextMenu.MarkAsSafe')}</div>
            </div>
          )
        : null}
      <div className={styles.menuItem} onClick={onCopyMessageID}>
        <Icon path="icons/icon-copy" style={IconStyles.medium} />
        <div>{t('Chat.Message.ContextMenu.CopyMessageID')}</div>
      </div>
      <div className={styles.menuItem} onClick={onShowSpamReport}>
        <Icon path="icons/icon-report" style={IconStyles.medium} />
        <div>{t('Chat.Message.ContextMenu.ShowSpamReport')}</div>
      </div>
    </>
  )
}
